import { call, put, takeEvery } from "redux-saga/effects"

import { GET_LEADS_DASHBOARD_STICKY_COLUMNS, UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS } from "./actionTypes"

import { getLeadsDashboardStickyColumnsSuccess, updateLeadsDashboardStickyColumnsError, updateLeadsDashboardStickyColumnsSuccess } from "./actions"

import { genericGetRequest, genericPutRequest } from "helpers/sf_backend_helper.js"

import { AppConfiguration } from "config"
import { getClicksDashboardStickyColumnsError } from "../clicks-dashboard-sticky-column/actions"


function* onGetLeadsDashboardStickyColumns() {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericGetRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_leads_dashboards`,
      {}, // no query parameters
      {
        Authorization: user.token,
        'Content-Type': 'application/json'
      }
    )
    yield put(getLeadsDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(getClicksDashboardStickyColumnsError(error))
  }
}

function* onUpdateLeadsDashboardStickyColumns(action) {
  try {
    let user = JSON.parse(localStorage.getItem("authUser")).user
    const response = yield call(
      genericPutRequest,
      `${AppConfiguration.BACKEND_URL}/api/v1/user_col_pref_leads_dashboards/${action?.payload?.user_col_pref_leads_dashboard?.id}`,
      {
        body: JSON.stringify({
          ...action.payload
        }),
        headers: {
          Authorization: user.token,
          'Content-Type': 'application/json'
        }
      }
    )
    yield put(updateLeadsDashboardStickyColumnsSuccess(response))
  } catch (error) {
    yield put(updateLeadsDashboardStickyColumnsError(error))
  }
}

function* userLeadsDashboardColumnPreferenceSaga() {
  yield takeEvery(GET_LEADS_DASHBOARD_STICKY_COLUMNS, onGetLeadsDashboardStickyColumns)
  yield takeEvery(UPDATE_LEADS_DASHBOARD_STICKY_COLUMNS, onUpdateLeadsDashboardStickyColumns)
}

export default userLeadsDashboardColumnPreferenceSaga;
